kdx-arrow-link + kdx-arrow-link {
	
	.arrow-link { margin-left: 8px; }
}
.arrow-link {
	position: relative;
	color: $primary;
	font-weight: 700;
	font-family: $font-family-secondary;
	text-decoration: none;
	display: inline-block;
	
	&.white-link {
		color: white !important;
	}
	svg {
		margin-left: 5px;
		@include svg-format(14px, 14px, currentColor);
		transition: transform .3s ease-in-out;
	}
	&:after {
		content: '';
		background: currentColor;
		height: 1px;
		width: 0px;
		position: absolute;
		top: 100%;
		left: 0;
		transition: width .3s ease-in-out;
	}
	&:hover, &:focus {
		outline: none;
		color: $link-hover-primary;

		&:after { width: 100%; }
		svg { 
			transform: translateX(4px);
		}
	}
}